import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "symbol symbol-50px" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("More Details")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CardTable = _resolveComponent("CardTable")!

  return (_openBlock(), _createBlock(_component_CardTable, {
    ref: "tableRef",
    name: "Customer",
    header: $setup.tableHeader,
    breadcrumbs: $setup.breadcrumbs,
    url: "lists",
    canCreate: false,
    endpoint: "customer"
  }, _createSlots({
    "cell-no": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString(row.no), 1)
    ]),
    "cell-profileImage": _withCtx(({ row }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "custom-image-box",
          style: _normalizeStyle(`background-image: url('${
            row.profileImage || 'media/images/steam-question-mark-icon-29.jpg'
          }')`)
        }, null, 4),
        false
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: 
            row.profileImage || 'media/images/steam-question-mark-icon-29.jpg'
          ,
              alt: "Picture"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true)
      ])
    ]),
    "cell-verifyState": _withCtx(({ row }) => [
      _createElementVNode("span", {
        class: _normalizeClass([
          row.verifyState === 'Done'
            ? 'badge-light-success text-w-emerald px-11'
            : 'badge-light-danger'
        , "badge badge-light-success px-8 py-3 fs-5"])
      }, _toDisplayString(row.verifyState === 'Done'
            ? 'Verified'
            : row.verifyState === 'WaitReviewVerify'
            ? 'WaitVerify'
            : 'Unverified'), 3)
    ]),
    "cell-details": _withCtx(({ row }) => [
      _createVNode(_component_router_link, {
        style: {"min-width":"151px"},
        class: "btn px-8 py-2 text-uppercase btn-primary",
        to: `lists/${row._id}`
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 2
      }, 1032, ["to"])
    ]),
    "cell-createdAt": _withCtx(({ row }) => [
      _createTextVNode(_toDisplayString($setup.moment(row.createdAt).format('DD/MM/YYYY')), 1)
    ]),
    _: 2
  }, [
    _renderList($setup.loopers, (item, i) => {
      return {
        name: `cell-${item}`,
        fn: _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row[item] || '-'), 1)
        ])
      }
    })
  ]), 1032, ["header", "breadcrumbs"]))
}